import { Button } from "@/components/ui/button";
import { AlertTriangle, Copy, Mail, Pause, Pencil, Play, Trash2 } from "lucide-react";
import { isBookingIncomplete } from "@/lib/constants";

const ActionBtn = ({ title, onClick, testId, tone = "", Icon }) => (
  <Button variant="ghost" size="icon" className={`h-8 w-8 ${tone}`} title={title} onClick={onClick} data-testid={testId}>
    <Icon className="h-4 w-4" />
  </Button>
);

// Per-row icon buttons: edit, rebook, NCR, hold/release, request update, delete.
export default function BookingRowActions({ row: r, actions: a }) {
  return (
    <div className="inline-flex items-center gap-0.5">
      <ActionBtn title="Edit" onClick={() => a.edit(r)} testId={`booking-edit-${r.id}`} Icon={Pencil} />
      <ActionBtn title="Rebook (clone +24h)" onClick={() => a.setRebookSource(r)} testId={`booking-rebook-${r.id}`} Icon={Copy} />
      <ActionBtn title="Mark as NCR" onClick={() => a.setNcrBooking(r)} testId={`booking-mark-ncr-${r.id}`}
                 tone="text-rose-600 hover:bg-rose-50" Icon={AlertTriangle} />
      {r.on_hold ? (
        <ActionBtn title="Release hold" onClick={() => a.unhold(r)} testId={`booking-unhold-${r.id}`}
                   tone="text-emerald-600 hover:bg-emerald-50" Icon={Play} />
      ) : (
        <ActionBtn title="Put on hold" onClick={() => a.hold(r)} testId={`booking-hold-${r.id}`}
                   tone="text-amber-600 hover:bg-amber-50" Icon={Pause} />
      )}
      {isBookingIncomplete(r) && (
        <ActionBtn title="Request update from booker" onClick={() => a.requestUpdate(r)} testId={`booking-request-update-${r.id}`}
                   tone="text-blue-600 hover:bg-blue-50" Icon={Mail} />
      )}
      <ActionBtn title="Delete" onClick={() => a.setConfirmDelete(r)} testId={`booking-delete-${r.id}`}
                 tone="text-red-600 hover:bg-red-50" Icon={Trash2} />
    </div>
  );
}
